// ================ Action types ================ //

// ================ Reducer ================ //

import { fetchCurrentUser } from '../../ducks/user.duck';

/** @type {import('../../../types/vansite').VanSite.State.SignupPage} */
const initialState = {};

const reducer = (state = initialState, action = {}) => {
  const { type } = action;
  switch (type) {
    default:
      return state;
  }
};

export default reducer;

// ================ Action creators ================ //

// ================ Thunks ================ //

export const loadData = (params, search, match) => {
  return fetchCurrentUser(params);
};
